import * as appConstants from '../constants/appConstants';
import * as appHelper from '../helpers/appHelper';
import * as dataHelper from '../helpers/dataHelper';
import * as userDataHelper from '../helpers/userDataHelper';
import * as suspendDataHelper from '../helpers/suspendDataHelper';
import * as badgeHelper from '../helpers/badgeHelper';
import * as xapiHelper from '../helpers/xAPIHelper';
import scormService from '../services/scormService';
import xAPIService from '../services/xAPIService';
import xAPIScormService from '../services/xAPIScormService';
import openLearningService from '../services/openLearningService';
import * as appData from '../models/appModels';
import * as types from './actionTypes';
import * as localStorage from '../localStorage/localStorage';
import * as objectConstants from '../constants/objectConstants';
import * as scormConstants from '../constants/scormConstants';
import * as dialogPopupActions from './dialogPopupActions';
import {XAPI_INIT_ACTOR_CONFIG} from '../models/dialogModels';
import {setStandardDialog} from '../helpers/dialogHelper';
import _ from 'lodash';

export function setTrackingData(trackingData) {
    return {type: types.SET_TRACKING_DATA, trackingData};
}

export function setDialogPopup(dialogPopup) {
    return {type: types.SET_DIALOG_POPUP, dialogPopup};
}

export function initTracking(contentData) {
    if (contentData.experience.tracking_type === appConstants.TRACKING_TYPE_SCORM) {
        return function (dispatch) {
            return scormService.initTracking().then(trackingData => {
                dispatch(setTrackingData(trackingData));
            }).catch(error => {
                throw(error);
            });
        };

    } else if (contentData.experience.tracking_type === appConstants.TRACKING_TYPE_XAPI) {
        return function (dispatch, getState) {
            const state = getState();
            let trackingData = state.trackingData;
            return xAPIService.checkActorDefined(contentData).then(lrs => {
                if (!appHelper.isDefined(trackingData.actor) && !appHelper.isDefined(lrs.lrs.actor) && contentData.experience.lrs.prompt_for_actor_if_needed) {
                    let dialogConfig = Object.assign({}, XAPI_INIT_ACTOR_CONFIG, {
                        title: `${localStorage.experience_locale.experience_title}`
                    });
                    return setStandardDialog(dialogConfig).then(dialogPopup => {
                        dispatch(setDialogPopup(dialogPopup));
                    }).catch(error => {
                        throw(error);
                    });
                }else if(!appHelper.isDefined(trackingData.actor) && !appHelper.isDefined(lrs.lrs.actor) && (appHelper.isDefined(contentData.experience.lrs.always_anonymous) && contentData.experience.lrs.always_anonymous)) {
                    let actor = xapiHelper.setUserAsAnonymous();
                    trackingData = Object.assign({},state.trackingData,{
                        actor: actor
                    });
                    return xAPIService.initTracking(contentData,trackingData).then(trackingData => {
                        dispatch(setTrackingData(trackingData));
                    }).catch(error => {
                        throw(error);
                    });
                } else {
                    let trackingData = state.trackingData;
                    if(!trackingData.initialised){
                        return xAPIService.initTracking(contentData,trackingData).then(trackingData => {

                            dispatch(setTrackingData(trackingData));
                        }).catch(error => {
                            throw(error);
                        });
                    }
                }
            }).catch(error => {
                throw(error);
            });

        };
    } else if (contentData.experience.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
        return function (dispatch) {
            return xAPIScormService.initTracking(contentData).then(trackingData => {
                dispatch(setTrackingData(trackingData));
            }).catch(error => {
                throw(error);
            });
        };
    } else if (contentData.experience.tracking_type === appConstants.TRACKING_TYPE_OPEN_LEARNING) {
        return function (dispatch) {
            return openLearningService.initTracking(contentData).then(trackingData => {
                dispatch(setTrackingData(trackingData));
            }).catch(error => {
                throw(error);
            });
        };
    } else {
        return function (dispatch) {

            let trackingData = Object.assign({}, appData.TRACKING_DATA, {
                initialised: true
            });

            if(appHelper.isDefined(contentData.experience.publish_details)){
                let student_name = contentData.experience.publish_details.published_by;
                let student_name_array = student_name.split(" ");
                let first_name = student_name_array[0];
                let last_name =  student_name_array[1];
                trackingData = Object.assign({}, trackingData, {
                    initialised: true,
                    student_name: student_name,
                    first_name: first_name,
                    last_name: last_name,
                });
            }

            dispatch(setTrackingData(trackingData));
            ////console.log('OPEN IT IS');
        };
    }
}

export function doLMSFinish(tracking_type) {
    //console.log('doLMSFinish');
    if (tracking_type === appConstants.TRACKING_TYPE_SCORM || tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
        return function (dispatch) {
            return scormService.doLMSFinish().then(trackingData => {
                return trackingData;
            }).catch(error => {
                throw(error);
            });
        };
    }
}

export function doLMSCommit(tracking_type) {
    //console.log('doLMSCommit');
    if (tracking_type === appConstants.TRACKING_TYPE_SCORM || tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
        return function (dispatch) {
            return scormService.doLMSCommit().then(trackingData => {
                return trackingData;
            }).catch(error => {
                throw(error);
            });
        };
    }
}

export function doQuickLMSFinish(tracking_type) {
    //console.log('doLMSFinish');
    if (tracking_type === appConstants.TRACKING_TYPE_SCORM || tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
        return function (dispatch) {
            return scormService.doQuickLMSFinish().then(trackingData => {
                return trackingData;
            }).catch(error => {
                throw(error);
            });
        };
    }
}

export function doQuickLMSCommit(tracking_type) {
    //console.log('doLMSCommit');
    if (tracking_type === appConstants.TRACKING_TYPE_SCORM || tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
        return function (dispatch) {
            return scormService.doQuickLMSCommit().then(trackingData => {
                return trackingData;
            }).catch(error => {
                throw(error);
            });
        };
    }
}

export function doLMSExit(tracking_type, exit_url){
    //console.log('doLMSExit');
    if (tracking_type === appConstants.TRACKING_TYPE_SCORM || tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
        return function (dispatch, getState) {
            const state = getState();
            let userData = state.userData;

            let scores = [];
            let totalScore = 0;
            let avgScore = 100;
            let totalweight = 0;
            _.forEach(userData.bites, function (bite) {
                let primaryKpi = appHelper.getArrayObjectByKey(bite.kpis, "is_primary", true);
                if(appHelper.isDefined(primaryKpi)) {
                    let score = dataHelper.getRangePercentage(primaryKpi.min, primaryKpi.max, primaryKpi.current);
                    if (isNaN(score)) {
                        score = scormConstants.CMI_CORE_SCORE_MAX_DEFAULT;
                    }

                    let weightedScore = score * bite.weight;

                    scores.push(weightedScore);
                    totalScore += weightedScore;
                    totalweight  += bite.weight;
                }
            });

            if(totalweight > 0){
                avgScore = Math.round(totalScore / totalweight);
            }

            //console.log(`(${totalScore} / ${scores.length}) = ${avgScore}`);
            scormService.setScoreRaw(avgScore).then(rawScoreResult => {
                scormService.setScoreMin(scormConstants.CMI_CORE_SCORE_MIN_DEFAULT).then(minScoreResult => {
                    scormService.setScoreMax(scormConstants.CMI_CORE_SCORE_MAX_DEFAULT).then(maxScoreResult => {
                        scormService.doLMSCommit().then(doLMSCommitResult => {
                            scormService.lmsGetScore();
                            scormService.lmsGetLessonStatus();
                            scormService.doLMSExit().then(result => {
                                //console.log(result);
                                scormService.doLMSCommit().then(commitResult => {
                                    //console.log(commitResult);
                                    //window.location = exit_url;
                                    scormService.doLMSFinish().then(finishResult => {
                                        //console.log(finishResult);
                                        //window.location = exit_url;
                                    }).catch(error => {
                                        throw(error);
                                    });
                                }).catch(error => {
                                    throw(error);
                                });
                            }).catch(error => {
                                throw(error);
                            });
                        }).catch(error => {
                            //console.log(`doLMSCommit error:`, error);
                            throw(error);
                        });
                    }).catch(error => {
                        //console.log(`maxScoreResult error:`, error);
                        throw(error);
                    }); //set cmi.core.score.raw //cmi.core.score.max

                }).catch(error => {
                    //console.log(`minScoreResult error:`, error);
                    throw(error);
                });

            }).catch(error => {
                //console.log(`rawScoreResult error:`, error);
                throw(error);
            }); //set cmi.core.score.raw
            //set cmi.core.score.raw //cmi.core.score.min*/
            /*return scormService.doLMSExit().then(result => {
                console.log(result);
                scormService.doLMSCommit().then(commitResult => {
                    console.log(commitResult);
                    //window.location = exit_url;
                }).catch(error => {
                    throw(error);
                });
            }).catch(error => {
                throw(error);
            });*/
        };
    }
}

export function setLessonLocation(screen_id) {

    return function (dispatch, getState) {
        const state = getState();
        let nextScreenId = screen_id;
        let trackingData = Object.assign({},state.trackingData);
        let last_lesson_location = 0;
        let location_history = Object.assign([],state.trackingData.location_history);
        let location_history_last_index = location_history.length - 1;
        //console.log(`${location_history_last_index} > -1 && ${location_history[location_history_last_index]} === ${nextScreenId}`);

        if(location_history_last_index > -1 && location_history[location_history_last_index] === nextScreenId){
            location_history = dataHelper.immutableSplice(location_history,location_history_last_index,1);
        }else if(location_history[location_history_last_index] !== trackingData.lesson_location){
            location_history = dataHelper.immutablePush(location_history,trackingData.lesson_location);
        }

        if(location_history.length > 0){
            last_lesson_location = location_history[location_history.length - 1];
        }

        trackingData = Object.assign({},state.trackingData,
            {
                lesson_location: nextScreenId,
                location_history: location_history,
                last_lesson_location: last_lesson_location
            }
        );

        /*let trackingData = Object.assign({}, state.trackingData,
            {
                lesson_location: screen_id
            }
        );*/
        //console.log(trackingData);
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_SCORM || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            return scormService.setLessionLocation(screen_id).then(result => {
                scormService.doLMSCommit().then(result => {
                    dispatch(setTrackingData(trackingData));
                    return result;
                }).catch(error => {
                    throw(error);
                });
            }).catch(error => {
                throw(error);
            });
        } else if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI) {
            return xAPIService.setLessionLocation(screen_id, state.trackingData.lrs).then(result => {
                dispatch(setTrackingData(trackingData));
                return result;
            }).catch(error => {
                throw(error);
            });
        } else if (localStorage.tracking_type === appConstants.TRACKING_TYPE_OPEN_LEARNING) {
            return openLearningService.setLessionLocation(screen_id).then(result => {
                dispatch(setTrackingData(trackingData));
                //return result;
            }).catch(error => {
                throw(error);
            });
        }

        dispatch(setTrackingData(trackingData));
    };

}

export function setNextLessonLocation(screen_id) {
    return function (dispatch, getState) {
        const state = getState();
        let nextScreenId = appHelper.getNextScreenId(screen_id);
        let trackingData = Object.assign({},state.trackingData);
        let last_lesson_location = 0;
        let location_history = Object.assign([],state.trackingData.location_history);
        let location_history_last_index = location_history.length - 1;
        //console.log(`${location_history_last_index} > -1 && ${location_history[location_history_last_index]} === ${nextScreenId}`);

        if(location_history_last_index > -1 && location_history[location_history_last_index] === nextScreenId){
            location_history = dataHelper.immutableSplice(location_history,location_history_last_index,1);
        }else if(location_history[location_history_last_index] !== trackingData.lesson_location){
            location_history = dataHelper.immutablePush(location_history,trackingData.lesson_location);
        }

        if(location_history.length > 0){
            last_lesson_location = location_history[location_history.length - 1];
        }

        trackingData = Object.assign({},state.trackingData,
            {
                lesson_location: nextScreenId,
                location_history: location_history,
                last_lesson_location: last_lesson_location
            }
        );



        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_SCORM || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            return scormService.setLessionLocation(nextScreenId).then(result => {
                scormService.doLMSCommit();
                dispatch(setTrackingData(trackingData));
                return result;
            }).catch(error => {
                throw(error);
            });
        } else if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI) {
            return xAPIService.setLessionLocation(nextScreenId, state.trackingData.lrs).then(result => {
                dispatch(setTrackingData(trackingData));
                return result;
            }).catch(error => {
                throw(error);
            });
        } else if (localStorage.tracking_type === appConstants.TRACKING_TYPE_OPEN_LEARNING) {
            return openLearningService.setLessionLocation(nextScreenId).then(result => {
                dispatch(setTrackingData(trackingData));
                //return result;
            }).catch(error => {
                throw(error);
            });
        }
        dispatch(setTrackingData(trackingData));
    };

}

export function setSuspendData(userData) {
    return function (dispatch, getState) {
        const state = getState();
        //console.log('setSuspendData');
        return suspendDataHelper.setSuspendData(userData).then(suspend_data => {
            let trackingData = Object.assign({}, state.trackingData,
                {
                    suspend_data: suspend_data

                }
            );



            switch (localStorage.tracking_type) {
                case appConstants.TRACKING_TYPE_SCORM:
                    scormService.setSuspendData(suspend_data); //set cmi.suspend_data

                    if (userData.status === objectConstants.STATUS_COMPLETE) {
                        scormService.setLessionStatus(scormConstants.LESSON_STATUS_COMPLETED).then(result => {
                            let scores = [];
                            let totalScore = 0;
                            let avgScore = 100;
                            let totalweight = 0;
                            _.forEach(userData.bites, function (bite) {
                                let primaryKpi = appHelper.getArrayObjectByKey(bite.kpis, "is_primary", true);
                                if(appHelper.isDefined(primaryKpi)) {
                                    let score = dataHelper.getRangePercentage(primaryKpi.min, primaryKpi.max, primaryKpi.current);
                                    if (isNaN(score)) {
                                        score = scormConstants.CMI_CORE_SCORE_MAX_DEFAULT;
                                    }

                                    let weightedScore = score * bite.weight;

                                    scores.push(weightedScore);
                                    totalScore += weightedScore;
                                    totalweight  += bite.weight;
                                }
                            });

                            if(totalweight > 0){
                                avgScore = Math.round(totalScore / totalweight);
                            }

                            scormService.setScoreRaw(avgScore).then(rawScoreResult => {
                                scormService.setScoreMin(scormConstants.CMI_CORE_SCORE_MIN_DEFAULT).then(minScoreResult => {
                                    scormService.setScoreMax(scormConstants.CMI_CORE_SCORE_MAX_DEFAULT).then(maxScoreResult => {
                                        scormService.doLMSCommit().then(doLMSCommitResult => {
                                            scormService.lmsGetScore();
                                            scormService.lmsGetLessonStatus();
                                        }).catch(error => {
                                            //console.log(`doLMSCommit error:`, error);
                                            throw(error);
                                        });
                                    }).catch(error => {
                                        //console.log(`maxScoreResult error:`, error);
                                        throw(error);
                                    }); //set cmi.core.score.raw //cmi.core.score.max

                                }).catch(error => {
                                    //console.log(`minScoreResult error:`, error);
                                    throw(error);
                                });

                            }).catch(error => {
                                //console.log(`rawScoreResult error:`, error);
                                throw(error);
                            }); //set cmi.core.score.raw
                             //set cmi.core.score.raw //cmi.core.score.min

                        }).catch(error => {
                            //console.log(`error:`, error);
                            throw(error);
                        }); //set cmi.core.lesson_status to completed


                    } else {
                        scormService.setLessionStatus(scormConstants.LESSON_STATUS_INCOMPLETE); //set cmi.core.lesson_status to incomplete
                    }
                    scormService.doLMSCommit();

                    break;
                case appConstants.TRACKING_TYPE_XAPI:
                    xAPIService.setSuspendData(suspend_data, state.trackingData.lrs).then(result => {
                        if (userData.status == objectConstants.STATUS_COMPLETE) {
                            xAPIService.markComplete(state.trackingData.lrs, userData.bites, localStorage.contentData);
                        }
                        return result;
                    }).catch(error => {
                        throw(error);
                    });
                    break;
                case appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2:
                    xAPIService.setSuspendData(suspend_data, state.trackingData.lrs).then(result => {
                        if (userData.status == objectConstants.STATUS_COMPLETE) {
                            xAPIService.markComplete(state.trackingData.lrs, userData.bites, localStorage.contentData);

                            scormService.setLessionStatus(scormConstants.LESSON_STATUS_COMPLETED); //set cmi.core.lesson_status to completed

                            let scores = [];
                            let totalScore = 0;
                            let avgScore = 100;
                            let totalweight = 0;
                            _.forEach(userData.bites, function (bite) {
                                let primaryKpi = appHelper.getArrayObjectByKey(bite.kpis, "is_primary", true);
                                if(appHelper.isDefined(primaryKpi)) {
                                    let score = dataHelper.getRangePercentage(primaryKpi.min, primaryKpi.max, primaryKpi.current);
                                    if (isNaN(score)) {
                                        score = scormConstants.CMI_CORE_SCORE_MAX_DEFAULT;
                                    }

                                    let weightedScore = score * bite.weight;

                                    scores.push(weightedScore);
                                    totalScore += weightedScore;
                                    totalweight  += bite.weight;
                                }
                            });

                            if(totalweight > 0){
                                avgScore = Math.round(totalScore / totalweight);
                            }
                            scormService.setScoreRaw(avgScore); //set cmi.core.score.raw
                            scormService.setScoreMin(scormConstants.CMI_CORE_SCORE_MIN_DEFAULT); //cmi.core.score.min
                            scormService.setScoreMax(scormConstants.CMI_CORE_SCORE_MAX_DEFAULT); //cmi.core.score.max
                        } else {
                            scormService.setLessionStatus(scormConstants.LESSON_STATUS_INCOMPLETE); //set cmi.core.lesson_status to incomplete
                        }
                        scormService.doLMSCommit();

                        return result;
                    }).catch(error => {
                        throw(error);
                    });

                    break;
                case appConstants.TRACKING_TYPE_OPEN_LEARNING:
                    openLearningService.setSuspendData(suspend_data).then(result => {
                        if (userData.status == objectConstants.STATUS_COMPLETE) {
                            openLearningService.markComplete(userData.bites, localStorage.contentData);
                        }
                        return result;
                    }).catch(error => {
                        throw(error);
                    });
                    break;
            }

            //console.log(userData.status);
            dispatch(setTrackingData(trackingData));
            return trackingData;
        }).catch(error => {
            throw(error);
        });
    };

}


export function setNewLessonLocation(screen_id) {

    return function (dispatch, getState) {
        const state = getState();
        let nextScreenId = screen_id;
        let trackingData = Object.assign({},state.trackingData);
        let last_lesson_location = 0;
        let location_history = Object.assign([],state.trackingData.location_history);
        let location_history_last_index = location_history.length - 1;
        //console.log(`${location_history_last_index} > -1 && ${location_history[location_history_last_index]} === ${nextScreenId}`);
        if(location_history_last_index > -1 && location_history[location_history_last_index] === nextScreenId){
            location_history = dataHelper.immutableSplice(location_history,location_history_last_index,1);
        }else if(location_history[location_history_last_index] !== trackingData.lesson_location){
            location_history = dataHelper.immutablePush(location_history,trackingData.lesson_location);
        }

        if(location_history.length > 0){
            last_lesson_location = location_history[location_history.length - 1];
        }

        trackingData = Object.assign({},state.trackingData,
            {
                lesson_location: screen_id,
                location_history: location_history,
                last_lesson_location: last_lesson_location
            }
        );

        //console.log(trackingData);
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_SCORM || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            return scormService.setLessionLocation(screen_id).then(result => {
                scormService.doLMSCommit();
                dispatch(setTrackingData(trackingData));
                return result;
            }).catch(error => {
                throw(error);
            });
        } else if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI) {
            return xAPIService.setLessionLocation(screen_id, state.trackingData.lrs).then(result => {
                dispatch(setTrackingData(trackingData));
                return result;
            }).catch(error => {
                throw(error);
            });
        } else if (localStorage.tracking_type === appConstants.TRACKING_TYPE_OPEN_LEARNING) {
            return openLearningService.setLessionLocation(screen_id).then(result => {
                dispatch(setTrackingData(trackingData));
                //return result;
            }).catch(error => {
                throw(error);
            });
        }

        dispatch(setTrackingData(trackingData));
    };

}

export function postActvityStatement(screen, interactionData, category, voidCompleteRecords) {
    return function (dispatch, getState) {
        const state = getState();

        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            return xAPIService.postActvityStatement(screen, interactionData, category, voidCompleteRecords, state.trackingData.lrs).then(result => {
                return result;
            }).catch(error => {
                throw(error);
            });
        }
    };
}

export function getActvityStatement(interactionData) {
    return function (dispatch, getState) {
        const state = getState();

        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            return xAPIService.getActivityStatement(interactionData, state.trackingData.lrs).then(result => {
                return result;
            }).catch(error => {
                throw(error);
            });
        }
    };
}


export function setScreenAccessed(screen, parentScreen) {
    return function (dispatch, getState) {
        const state = getState();
        let userData = state.userData;
        let bite_id = appHelper.getBiteByScreenId(screen.screen_id);
        let bite = appHelper.getBiteById(bite_id);
        let userDataBite = appHelper.getArrayObjectByKey(userData.bites,"bite_id",bite.bite_id);
        let biteStatus = userDataHelper.getBiteStatus(userDataBite);


        /*if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            return xAPIService.setScreenAccessed(screen, parentScreen, bite, state.trackingData.lrs).then(result => {

                return xAPIService.setBiteProgressStatus(bite,biteStatus, userDataBite, parentScreen, state.trackingData.lrs).then(result => {

                }).catch(error => {
                    throw(error);
                });
            }).catch(error => {
                throw(error);
            });
        }*/
    };
}


export function setScreenComplete(screen, parentScreen) {
    return function (dispatch, getState) {

        const state = getState();
        let userData = state.userData;
        let bite_id = appHelper.getBiteByScreenId(screen.screen_id);
        let bite = appHelper.getBiteById(bite_id);
        let userDataBite = appHelper.getArrayObjectByKey(userData.bites,"bite_id",bite.bite_id);
        let biteStatus = userDataHelper.getBiteStatus(userDataBite);

        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            return xAPIService.setScreenComplete(screen, parentScreen, bite, state.trackingData.lrs).then(result => {
                return xAPIService.setBiteCompleteStatus(bite,biteStatus, userDataBite, parentScreen, state.trackingData.lrs).then(result => {
                }).catch(error => {
                    throw(error);
                });
            }).catch(error => {
                throw(error);
            });
        }
    };
}

export function setBadgeStatement(badge) {
    return function (dispatch, getState) {
        const state = getState();
        let bite_id = badgeHelper.getBadgeParentBiteId(badge.badge_id);
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            return xAPIService.setBadgeStatement(badge, bite_id, state.trackingData.lrs).then(result => {
                return result;
            }).catch(error => {
                throw(error);
            });
        }
    };
}

export function setActorDetails(actor) {
    return function (dispatch, getState) {
        const state = getState();
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI) {
            let trackingData = Object.assign({},state.trackingData,{
                actor: actor
            });
            dispatch(setTrackingData(trackingData));
        }
    };
}


/** WEBPACK FOOTER **
 ** ./src/actions/trackingDataActions.js
 **/